/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityIntegration } from './FacilityIntegration';
import {
    FacilityIntegrationFromJSON,
    FacilityIntegrationFromJSONTyped,
    FacilityIntegrationToJSON,
    FacilityIntegrationToJSONTyped,
} from './FacilityIntegration';

/**
 * 
 * @export
 * @interface FindAllIntegrationsByFacilityId200Response
 */
export interface FindAllIntegrationsByFacilityId200Response {
    /**
     * 
     */
    data?: Array<FacilityIntegration>;
}

/**
 * Check if a given object implements the FindAllIntegrationsByFacilityId200Response interface.
 */
export function instanceOfFindAllIntegrationsByFacilityId200Response(value: object): value is FindAllIntegrationsByFacilityId200Response {
    return true;
}

export function FindAllIntegrationsByFacilityId200ResponseFromJSON(json: any): FindAllIntegrationsByFacilityId200Response {
    return FindAllIntegrationsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllIntegrationsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIntegrationsByFacilityId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FacilityIntegrationFromJSON)),
    };
}

export function FindAllIntegrationsByFacilityId200ResponseToJSON(json: any): FindAllIntegrationsByFacilityId200Response {
    return FindAllIntegrationsByFacilityId200ResponseToJSONTyped(json, false);
}

export function FindAllIntegrationsByFacilityId200ResponseToJSONTyped(value?: FindAllIntegrationsByFacilityId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FacilityIntegrationToJSON)),
    };
}

